// extracted by mini-css-extract-plugin
module.exports = {"cardPaddingsOverwrite":"MobileContent__cardPaddingsOverwrite___s+4u8"};